import React from 'react'
import { Flex, Image } from '@chakra-ui/react'
import { HSeparator } from 'components/separator/Separator'
import MyLogoImage from '../../../assets/img/logo/bamyan.png' 

export function SidebarBrand () {
  // let logoColor = useColorModeValue("navy.700", "white");

  return (
    <Flex align='center' direction='column'>
      <Image
        src={MyLogoImage}
        alt='Your Company Logo'
        h='120px'
        w='120px'
        my='5px'
      />

      <HSeparator mb='20px' />
    </Flex>
  )
}

export default SidebarBrand
